import React, { useState } from "react";
import logo from "../../../assets/img/logo.png";
import { toast } from "react-toastify";
import axios from "axios";

const ForgotPassword = () => {
  const [email, setEmail] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      toast.error("Please enter your email");
      return;
    }

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/users/password`,
        { email }
      );
      toast.success("Password reset email sent successfully.", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        draggable: true,
        theme: "colored",
      });
    } catch (error) {
      console.error("Error sending email:", error);
      toast.error(
        error?.response?.data?.message || "Failed to send password reset email",
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          draggable: true,
          theme: "colored",
        }
      );
    }
  };

  return (
    <section className="auth">
      <div className="wrapper">
        <div className="form signup">
          <img
            src={logo}
            alt="Logo"
            style={{ width: "180px", height: "auto" }}
          />
          <form autoComplete="off" onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@example.com"
                required
              />
            </div>
            <div className="form-group">
              <button type="submit" className="btn btn-primary w-100">
                Send Email
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default ForgotPassword;